module.exports = __webpack_public_path__ + "img/icon-clzl@2x.bcb6dfac.png";